module.exports = __webpack_public_path__ + "static/media/honor-card.48d8b7ae.svg";